(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('externalChannelConstants', {
            SHOWKASE: 'invoice.salesChannel.options.SHOWKASE',
            TIKTOK_SHOPPING: 'invoice.salesChannel.options.TIKTOK_SHOPPING',
            INSTAGRAM: 'invoice.salesChannel.options.INSTAGRAM',
            GOOGLE: 'invoice.salesChannel.options.GOOGLE',
            FACEBOOK: 'invoice.salesChannel.options.FACEBOOK',
            PHYSICAL_STORE: 'invoice.salesChannel.options.PHYSICAL_STORE',
            MARKETPLACE: 'invoice.salesChannel.options.MARKETPLACE',
            WHATSAPP: 'invoice.salesChannel.options.WHATSAPP'
        });
})();
